import styled from 'styled-components/macro';

export const MessageAttachmentWrapper = styled.div`
  display: ${(props) => (props.hide ? 'none' : 'initial')};
  padding: 20px 20px 20px 0px;

  & > img {
    max-width: 100%;
    max-height: 350px;
    border-radius: 10px;
  }
`;
